export default function(http) {
  return {
      tree(params){
        return http.json({
          url: `/windows/xsc-house-info/tree`,
          params
        });
      },
      queryByPage(data){
        return http.json({
          url: `/windows/xsc/house/query`,
          data
        });
      },
      updateState(data){
        return http.json({
          url: `/windows/xsc/house/updatePayState`,
          data
        })
      },
      updatePayByMonth(data){
        return http.json({
          url: `/windows/xsc/house/updatePayByMonth`,
          data
        })
      },

      updateIsPayOrder(data){
        return http.json({
          url: `/windows/xsc/house/updateIsPayOrder`,
          data
        })
      },

      updateIsLottery(data){
        return http.json({
          url: `/windows/xsc/house/updateIsLottery`,
          data
        })
      },

      getInfo(data) {
        return http({
          url: `/windows/xsc/house/get?id=${data.id}`,
          method: 'post'
        });
      },

      saveInfo(data) {
        return http.json({
          url: '/windows/xsc/house/save',
          method: 'post',
          data
        });
      },

      list(data) {
        return http.json({
          url: '/windows/xsc/house/list',
          data
        });
      },
      syncInfo(data) {
        return http.json({
          url: '/windows/xsc/house/syncHouseInfo',
          data
        });
      }
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/xschouseInfo.js